import { format } from "date-fns";
import { LocalDateString } from "@lib/store/src/data/timeslots/apiTypes";
import { P } from "@quarks";
import { AttendanceItem } from "./AttendanceItem";
import { useMemoDate } from "@lib/store/src/ui/hooks/useMemoDate";
import { useConnections } from "@pages";

export const DayItem = ({ dayKey }: { dayKey: LocalDateString }) => {
  const { compactView, showWeekends, canShowFullContent } = useConnections();

  const date = useMemoDate(dayKey);

  const formatString = [
    [showWeekends && compactView, "cccccc"],
    [!showWeekends && compactView, "cccccc"],
    [!showWeekends && !canShowFullContent, "EEEE"],
  ] as const;
  const selectedFormat = (formatString.find(([condition]) => condition)?.[1] as string) ?? "EEE";

  const dayName = format(date, selectedFormat);
  const dayNumber = format(date, canShowFullContent || showWeekends ? "d" : "d MMMM");

  return (
    <div className="flex flex-col gap-2 items-center md:items-start leading-4 ">
      <div className="grid gap-1 text-center sm:text-left">
        <small className="text-mapiq-black-500">{dayName}</small>
        <P
          fontWeight="bold"
          className="text-nowrap">
          {dayNumber}
        </P>
      </div>

      <AttendanceItem dayKey={dayKey} />
    </div>
  );
};
